import mediaProvider, { QueryParams } from '@/data-provider/mediaProvider';

const useDownloaddMedia = () => {
  const downloadMediaUrl = (id: string, qs: QueryParams = {}): Promise<string> =>
    mediaProvider.getMediaDownloadUrl(id, qs);
  const downloadMediaFile = (url: string) => mediaProvider.downloadMedia(url);

  return {
    downloadMediaFile,
    downloadMediaUrl,
  };
};

export default useDownloaddMedia;
